const MuiAlertTitle = {
  styleOverrides: {
    root: {
      fontFamily: 'mark-ot-bold',
    },
  },
}

export default MuiAlertTitle
